'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosIonicOutline = function IoIosIonicOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33 10.5c1.9 2.7 3 6 3 9.5 0 9-7.2 16.3-16.2 16.3s-16.3-7.3-16.3-16.3 7.3-16.2 16.3-16.2c3.5 0 6.7 1 9.4 2.9 0.5-0.4 1-0.6 1.6-0.6 1.5 0 2.8 1.2 2.8 2.7 0 0.7-0.2 1.3-0.6 1.7z m-2.2-3.4c-0.9 0-1.7 0.8-1.7 1.7s0.8 1.7 1.7 1.7 1.8-0.7 1.8-1.7-0.8-1.7-1.8-1.7z m-0.4 23.5c1.4-1.4 2.4-3 3.2-4.8 0.8-1.9 1.2-3.8 1.2-5.8s-0.4-4-1.2-5.9c-0.4-1-1-1.9-1.6-2.8-0.4 0.2-0.8 0.3-1.2 0.3-1.4 0-2.7-1.3-2.7-2.8 0-0.4 0.2-0.8 0.3-1.1-0.8-0.7-1.8-1.2-2.8-1.6-1.9-0.8-3.8-1.1-5.8-1.1s-4 0.3-5.9 1.1c-1.8 0.8-3.4 1.9-4.8 3.3s-2.4 2.9-3.2 4.7c-0.8 1.9-1.1 3.9-1.1 5.9s0.3 3.9 1.1 5.8c0.8 1.8 1.8 3.4 3.2 4.8s3 2.4 4.8 3.2c1.9 0.8 3.8 1.2 5.9 1.2s3.9-0.4 5.8-1.2c1.8-0.8 3.4-1.8 4.8-3.2z m-10.6-18.1c4.1 0 7.5 3.4 7.5 7.5s-3.4 7.5-7.5 7.5-7.5-3.4-7.5-7.5 3.3-7.5 7.5-7.5z m0 13.8c3.4 0 6.2-2.9 6.2-6.3s-2.8-6.2-6.2-6.2-6.2 2.8-6.2 6.2 2.7 6.3 6.2 6.3z' })
        )
    );
};

exports.default = IoIosIonicOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-ionic-outline.js
// module id = 2219
// module chunks = 0